import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { TrustBadge } from "@/components/app/TrustBadge";
import { FileText, Package, ArrowRight } from "lucide-react";

export default function SupplierDashboard() {
  const { user } = useAuth();
  const [rfqs, setRfqs] = useState([]);
  const [quotes, setQuotes] = useState([]);
  const [orders, setOrders] = useState([]);
  useEffect(() => {
    Promise.all([api.get("/rfqs"), api.get("/quotes"), api.get("/orders")])
      .then(([a,b,c]) => { setRfqs(a.data); setQuotes(b.data); setOrders(c.data); });
  }, []);
  return (
    <div className="space-y-8">
      <div>
        <div className="eyebrow text-[hsl(var(--navy))] opacity-70 mb-2">Supplier workspace</div>
        <h1 className="font-display text-3xl md:text-4xl">Welcome, {user?.full_name?.split(" ")[0]}</h1>
        <div className="mt-3 inline-flex items-center gap-2 text-sm">
          <TrustBadge level="unverified"/>
          <Link to="/supplier/profile" className="text-[hsl(var(--navy))] hover:underline">Complete your profile to request verification →</Link>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {[
          ["Incoming RFQs", rfqs.length, FileText],
          ["Quotations submitted", quotes.length, FileText],
          ["Active orders", orders.length, Package],
        ].map(([l,v,I]) => (
          <div key={l} className="surface p-5">
            <div className="text-xs uppercase tracking-wider text-slate-500">{l}</div>
            <div className="font-display text-3xl mt-2">{v}</div>
          </div>
        ))}
      </div>
      <div className="surface">
        <div className="px-5 py-4 border-b border-slate-200 flex items-center justify-between">
          <div className="font-display text-lg">Incoming RFQs</div>
          <Link to="/supplier/rfqs" className="text-sm hover:underline" data-testid="see-all-rfqs">View all →</Link>
        </div>
        {rfqs.length === 0 ? (
          <div className="p-10 text-center text-slate-500">No RFQs have been routed to your account yet. Keep your profile complete to receive more opportunities.</div>
        ) : (
          <ul className="divide-y divide-slate-100">
            {rfqs.slice(0,5).map((r) => (
              <li key={r.id}>
                <Link to={`/supplier/rfqs`} className="block px-5 py-4 hover:bg-slate-50">
                  <div className="flex items-center justify-between">
                    <div className="font-medium">{r.content?.title || "RFQ"}</div>
                    <ArrowRight size={14}/>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
